export const projects = [
  {
    "id": "middesk",
    "company": "Middesk"
  },
  {
    "id": "runway",
    "company": "Runway"
  },
  {
    "id": "broadridge",
    "company": "Broadridge"
  }
];

